import React from 'react';
import { View, Text, ScrollView, ActivityIndicator, Image, TextInput, CheckBox, FlatList } from 'react-native';
import { Button } from 'react-native-elements';
import screen from '../screen';
import Icon from 'react-native-vector-icons/FontAwesome';
import Lib from '../Lib';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'modal-enhanced-react-native-web';
import log from 'loglevel';
import evmLib from '../evmLib';

const vp = screen.vp;

function to2dec(amount) {
  return (Math.round(Number(amount) * 100) / 100);
}

class Analytic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ts: 0
    };
  }

  async componentDidMount() {
    this.interval = setInterval(() => {
      this.setState({ ts: moment().unix() });
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  renderHeader() {
    const s = { flex: 1 };
    const ts1 = { fontWeight: 'bold' };
    const ts2 = { fontWeight: 'bold', textAlign: 'right' };
    return (<View style={{}}>
      <View style={{ backgroundColor: 'black', borderBottomWidth: 1, padding: 2 * vp, alignItems: 'center', justifyContent: 'center' }}>
        <Text style={{ color: 'white', textAlign: 'center', fontWeight: 'bold' }}>LP Vault Reward History</Text>
      </View>
      <View style={{ flexDirection: 'row', padding: 2 * vp }}>
        <View style={{ flex: 1 }}>
          <Text style={ts1}>XYZ Minted</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>Total LP Staked</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>XYZ/LP Reward</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>Timestamp</Text>
        </View>
      </View>
    </View>
    );
  }

  renderRow(item, index) {
    const ts1 = {};
    const ts2 = { textAlign: 'right' };
    return (
      <View style={{ flexDirection: 'row', backgroundColor: 'white', padding: 2 * vp }}>
        <View style={{ flex: 1 }}>
          <Text style={ts1}>{Math.floor(item.reward)}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>{Math.floor(item.totLP)}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>{to2dec(item.rps)}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={ts2}>{item.datetime}</Text>
        </View>
      </View>
    );
  }

  renderStatCell(title, value) {
    const ts1 = { textAlign: 'center' };
    const ts2 = { textAlign: 'center', fontWeight: 'bold', fontSize: 24 };
    return (
      <View style={{
        flex: 1, padding: 2 * vp,
        borderWidth: 1, borderColor: 'gainsboro', alignItems: 'center', justifyContent: 'center'
      }}>
        <Text style={ts1}>{title}</Text>
        <Text style={ts2}>{value}</Text>
      </View>
    );
  }

  renderStat() {
    const space = <View style={{ width: vp, height: vp }} />
    const lp = this.props.lpvaultData;
    const td = this.props.treasuryData;
    const nd = this.props.nftData;

    const ta = td && td.balanceUSDT ? '$' + Math.floor(td.balanceUSDT) : '-';
    const cm = nd && nd.dataList ? nd.totalNFT + '/100 NFT' : '-';
    const ps = nd && nd.dataList ? (nd.totalNFT * 1000) + ' CFX' : '-';
    const vs = lp && lp.valueStaked ? '$' + lp.valueStaked : '-';

    let nut = '-';
    if (nd && nd.nextUpdateTime) {
      let dt = nd.nextUpdateTime - moment().unix();
      if (dt < 0) dt = 0;
      nut = Lib.remainingText(dt);
    }
    return (
      <View style={{ backgroundColor: 'white' }}>
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            {this.renderStatCell('Treasury Assets', ta)}
          </View>
          {space}
          <View style={{ flex: 1 }}>
            {this.renderStatCell('Cult Members', cm)}
          </View>
        </View>
        {space}
        <View style={{ flex: 1, flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            {this.renderStatCell('PoS Staked', ps)}
          </View>
          {space}
          <View style={{ flex: 1 }}>
            {this.renderStatCell('LP Vault Staked', vs)}
          </View>
        </View>
        {space}
        {/* <View style={{ flex: 1, flexDirection: 'row' }}>
          <View style={{ flex: 1 }}>
            {this.renderStatCell('Next Mint to Daily Reward', ps)}
          </View>
          {space}
          <View style={{ flex: 1 }}>
            {this.renderStatCell('Next Mint to LP Vault', vs)}
          </View>
        </View>
        {space} */}
        <View style={{ flex: 1 }}>
          {this.renderStatCell('Next Epoch', nut)}
        </View>
      </View>
    );
  }

  render() {
    let rows = [];
    const lpvd = this.props.lpvaultData;
    if (lpvd && lpvd.rewardHistory) {
      rows = lpvd.rewardHistory;
    }
    return (
      <View style={{ flex: 1, backgroundColor: 'white', maxWidth: 100 * vp, padding: 2 * vp }}>
        {this.renderStat()}
        <Text> </Text>
        <View style={{ borderWidth: 1, borderColor: 'gainsboro' }}>
          <FlatList
            data={rows}
            renderItem={({ item, index }) => this.renderRow(item, index)}
            ListHeaderComponent={() => this.renderHeader()}
            ItemSeparatorComponent={() => {
              return (
                <View style={{ backgroundColor: 'gainsboro', height: 1 }} />
              );
            }}
          />
        </View>
      </View>
    );
  }

}

export default Analytic;
